const illegalRe = /[/?<>\\:*|"]/g;
// const controlRe = /[\x00-\x1f\x80-\x9f]/g;

export const sanitize = (input: string) => {
    if (typeof input !== "string") {
        throw new Error("Input must be string");
    }
    return input.replace(illegalRe, "");
};
